import React, { useState, useEffect, useContext } from "react";

import { UserContext } from "../../UserContext";
import {
  GetNonCompliantRowers,
  UpdateStudentPhotograph,
  UpdateStudentDeclaration,
  UpdateStudentCNIC,
} from "../../APIManager";

import { Typography, Divider, Space, Table } from "antd";

import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";

import UploadedFile from "../Shared Components/UploadedFile";

import styles from "./RowerFileUploads.module.css";

const { Title } = Typography;

export default function RowerPhotoReUploads() {
  const [user, setUser] = useContext(UserContext);
  const [isLoading, SetIsLoading] = useState(true);
  const [SelectedUserID, SetSelectedUserID] = useState("");
  const [students, SetStudents] = useState([]);
  const [photographModalOpen, SetPhotographModalOpen] = useState(false);
  const [cnicModalOpen, SetCNICModalOpen] = useState(false);
  const [declarationModalOpen, SetDeclarationModalOpen] = useState(false);
  const [isChangeMode, SetIsChangeMode] = useState(false);

  const selectedStudent = students.filter((s) => s._id == SelectedUserID)[0];

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a, b) => a.Name.localeCompare(b.Name),
      sortDirections: ["ascend", "descend"],
      onFilter: (value, record) => record.Name.indexOf(value) === 0,
    },
    {
      title: "CNIC Number",
      dataIndex: "CNICNumber",
    },
    {
      title: "Photograph",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <a
            onClick={() => {
              SetSelectedUserID(record._id);
              SetPhotographModalOpen(true);
            }}
          >
            {record.Photograph ? (
              <>
                <span>
                  {" "}
                  <UploadedFile
                    FileLabel={"View Photograph"}
                    FileURL={selectedStudent?.Photograph}
                    newUploadMode={false}
                    FileType={"StudentPhoto"}
                    UploadAPIFunction={(file) => {
                      UpdateStudentPhotograph(
                        file,
                        selectedStudent?.Name,
                        selectedStudent.KBCNumber,
                        selectedStudent._id,
                      ).then(() => {
                        FetchStudents();
                      });
                    }}
                    OnSubmit={() => {}}
                    dontShowFileLabel
                    AllowAfterSubmission
                    modalTitle={`Change photograph of ${selectedStudent?.Name}`}
                    buttonJSX={
                      <>
                        {" "}
                        <CloseCircleTwoTone twoToneColor="#eb2f96" />
                        Change
                      </>
                    }
                  />
                </span>
              </>
            ) : (
              <>
                {" "}
                <span>
                  {" "}
                  <UploadedFile
                    FileLabel={""}
                    FileURL={selectedStudent?.Photograph}
                    newUploadMode={true}
                    FileType={"StudentPhoto"}
                    UploadAPIFunction={(file) => {
                      UpdateStudentPhotograph(
                        file,
                        selectedStudent?.Name,
                        selectedStudent.KBCNumber,
                        selectedStudent._id,
                      ).then(() => {
                        FetchStudents();
                      });
                    }}
                    OnSubmit={() => {}}
                    dontShowFileLabel
                    modalTitle={`Upload photograph of ${selectedStudent?.Name}`}
                    buttonJSX={
                      <>
                        {" "}
                        <CloseCircleTwoTone twoToneColor="#eb2f96" />
                        Upload
                      </>
                    }
                  />
                </span>
              </>
            )}
          </a>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    FetchStudents().then(() => {
      SetIsLoading(false);
    });
  }, []);

  async function FetchStudents() {
    const resRowers = await GetNonCompliantRowers();

    SetStudents(resRowers.data.reverse());
  }

  return (
    <div>
      {" "}
      <Divider>
        {" "}
        <Title level={3}>Rejected Photos</Title>
      </Divider>
      <Typography>
        Please re-upload the photographs for the following rowers as they were
        not accepted. Click on "Change" to upload a new photograph.
      </Typography>
      <br />
      <Table
        columns={columns}
        dataSource={students}
        pagination={{ defaultPageSize: 200 }}
        loading={{
          spinning: isLoading,
          tip: "Loading data...",
        }}
        locale={{
          emptyText: isLoading ? (
            <div style={{ minHeight: "100px" }} />
          ) : (
            <div className={styles.TableNoRowers}>
              <CheckCircleTwoTone
                twoToneColor="#52c41a"
                style={{ fontSize: "38px", marginRight: "12px" }}
              />
              All photos have been verified!
            </div>
          ),
        }}
      />
    </div>
  );
}
